import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type PlanRoute from '../plan';

export default class AuthenticatedCareerPathwaysPlanIndexRoute extends Route {
  model(): ModelFrom<PlanRoute> {
    return this.modelFor('authenticated.reimagined.plan') as ModelFrom<PlanRoute>;
  }
}
